export default function CsharpOop() {
  return (
    <h2>Csharp OOP</h2>
  );
}
